<div class="nav-footer">
    <div class="container flex">
        <div *ngFor="let menu of infoMenu" class="nav-footer__box">
            <p class="nav-footer__box_title" (click)="openMenu($event)">{{ menu.title }}</p>
            <ul class="nav-footer__links">
                <li *ngFor="let link of menu.links">
                    <a class="nav-footer__links_item" href="{{ link.url }}">{{ link.label }}</a>
                </li>
            </ul>
        </div>
    </div>
</div>
